var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.3634 17.9999C10.0874 17.9999 9.82338 17.8859 9.63438 17.6849L4.77138 12.5059C4.39238 12.1039 4.41338 11.4709 4.81538 11.0929C5.21838 10.7149 5.85138 10.7349 6.22838 11.1369L10.3534 15.5279L18.7614 6.32587C19.1354 5.91687 19.7674 5.88987 20.1754 6.26187C20.5824 6.63387 20.6104 7.26687 20.2384 7.67387L11.1014 17.6739C10.9144 17.8799 10.6484 17.9979 10.3704 17.9999H10.3634Z","fill":"#003308"}));
}

Checkmark.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
